export default class Ui {
    constructor( core ) {
        this.core = core
    }

    SetLoading( loading, logName ) {
        this.core.updateStore({
            ui: { is_loading: {$set: loading } }
        }, logName)
    }

    openMobileMenu() {
        this.core.updateStore({
            ui: { open_mobile_menu: {$set: true } }
        })
    }

    closeMobileMenu() {
        this.core.updateStore({
            ui: { open_mobile_menu: {$set: false } }
        })
    }

    toggleMobileMenu() {
        const { store } = this.core

        const { ui } = store.getState()

        const { open_mobile_menu = false } = ui

        this.core.updateStore({
            ui: { open_mobile_menu: {$set: !open_mobile_menu } }
        })
    }
}